<i18n locale="en" lang="json">
{
  "unexpected_error": "Unexpected error",
  "message": "Something went wrong and this page may not work properly. Our technicians have been notified and will do their best to avoid this error in the future. We apologise for the inconvenience.",
  "advice": "You can continue where you left off or reload this screen if the issue remains.",
  "continue": "Continue",
  "reload": "Reload"
}
</i18n>
<i18n locale="nl" lang="json">
{
  "unexpected_error": "Onverwachte fout",
  "message": "Er is iets fout gegaan waardoor deze pagina misschien niet goed werkt. Onze technici zijn op de hoogte gebracht en zullen hun best doen om deze fout in de toekomst te voorkomen. Excuses voor het ongemak.",
  "advice": "U kunt verdergaan of dit scherm herladen als het probleem aanhoudt.",
  "continue": "Verder gaan",
  "reload": "Herladen"
}
</i18n>

<template>
  <v-dialog
    :model-value="isOpen"
    max-width="500"
    @update:model-value="(b: boolean) => $emit('update:is-open', b)"
  >
    <base-card :title="t('unexpected_error')" test-id="TheApolloErrorDialog">
      <p>{{ t('message') }}</p>
      <p>{{ t('advice') }}</p>
      <template #actions>
        <base-button
          :primary="!cancelable"
          @click="$emit('reload-pressed', $event)"
        >
          {{ t('reload') }}
        </base-button>
        <base-button
          v-if="cancelable"
          primary
          @click="$emit('cancel-pressed', $event)"
        >
          {{ t('continue') }}
        </base-button>
      </template>
    </base-card>
  </v-dialog>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n';
import type {
  DialogEmits,
  DialogProps,
} from '@/common/components/zvdzo/BaseDialog.types';

type Props = DialogProps & { cancelable?: boolean };
defineProps<Props>();
type Emits = DialogEmits & {
  (e: 'reload-pressed' | 'cancel-pressed', v: Event): void;
};
defineEmits<Emits>();
const { t } = useI18n();
</script>
